import { atom } from 'jotai';
import { atomWithHash } from 'jotai-location';
import type { FormInstance } from 'antd/es/form';

export function isAntFormInstance(form: unknown): form is FormInstance {
    return Boolean(form && typeof (form as FormInstance).setFieldsValue === 'function');
}

// Atom for the current tab
export const currentStepAtom = atomWithHash<string>('step', 'upload-files');

// Atoms for form data
export const releaseInfoFormAtom = atom<any>({});
export const artTracksFormAtom = atom<any>({});
export const submitFormAtom = atom<any>({});

// Atom for combined form data
export const combinedFormDataAtom = atom(
  (get) => {
    const releaseInfo = get(releaseInfoFormAtom);
    const artTracks = get(artTracksFormAtom);
    const submit = get(submitFormAtom);
    return {
      ...releaseInfo,
      ...artTracks,
      ...submit
    };
  }
);

// Atom for form instances
export const useReleaseInfoForm = atom<FormInstance | null>(null);
export const useArtTracksForm = atom<FormInstance | null>(null);
export const useSubmitForm = atom<FormInstance | null>(null);

// Atom for upload progress
export const uploadProgressAtom = atom<number>(0);


export const previewImageAtom = atom<string>('');

// Last GenAI disclosure chosen on the release form. Applied to every track,
// and used as the starting value for tracks added afterwards.
export const releaseGenAIDisclosureAtom = atom('');